import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { previewTemplate } from '../services/documentTemplates';
import type { PreviewSource } from '../types/documentTemplates.types';

export function useTemplatePreview(templateId: string) {
  const [isOpen, setIsOpen] = useState(false);
  const mutation = useMutation({ mutationFn: (source: PreviewSource) => previewTemplate(templateId, source) });
  const { mutate, reset } = mutation;

  const open = (source: PreviewSource) => {
    setIsOpen(true);
    mutate(source);
  };

  const close = () => {
    setIsOpen(false);
    reset();
  };

  return {
    isOpen,
    open,
    close,
    isLoading: mutation.isPending,
    error: mutation.error,
    preview: mutation.data ?? null,
  };
}
